import React, { useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useSquareAuth } from '../hooks/useSquareExternal';
import { SystemUpdateAlt } from '@material-ui/icons';

const useStyles = makeStyles({
    buttonLink: {
        textDecoration: "none",
    },
    buttonText: {
        marginLeft: "12px",
    },
})

export interface ISquareAuthorisationButton {
    enabledText: string;
    disabledText: string;
    csrfToken: string | null;
}

const SquareAuthorisationButton = ({enabledText, disabledText, csrfToken} : ISquareAuthorisationButton) => {
    const classes = useStyles();
    const { squareUrl } = useSquareAuth();
    const [ isButtonDisabled, setIsButtonDisabled] = useState(false);
    const onButtonClick = () => {
        setIsButtonDisabled(true);
    }

    return (
        <a className={classes.buttonLink} href={`${squareUrl}&state=${csrfToken}`}>
            <Button 
                style={{padding: "12px 18px"}}
                variant={'contained'} 
                color={'primary'}
                disabled={isButtonDisabled}
                onClick={onButtonClick}
            >
                <SystemUpdateAlt />
                <span className={classes.buttonText}>{
                    isButtonDisabled ? disabledText : enabledText
                        
                }</span>
            </Button>
        </a>
    )
}

export default SquareAuthorisationButton;